import { render, staticRenderFns } from "./florist-review-update.vue?vue&type=template&id=759c021b"
import script from "./florist-review-update.vue?vue&type=script&lang=js"
export * from "./florist-review-update.vue?vue&type=script&lang=js"
import style0 from "./florist-review-update.vue?vue&type=style&index=0&id=759c021b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../florida-ecommerce/admin-dashboard/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports